import dayjs from 'dayjs';

import {
  GetBoardCategoriesQuery,
  GetBoardCommentBelongedBoardCommentsQuery,
  GetCommunityUserQuery,
  GetMagazineRelatedBoardPostsQuery,
} from '@/types/bff/gql-schema';
import {
  BoardComment,
  CommunityUser,
  MagazineRelatedPost,
  boardCategoryVo,
} from '@/types/community';
import { displayedAt } from '@/utils/format';

export const parseBoardCategories = (
  data: GetBoardCategoriesQuery,
): Array<boardCategoryVo> => {
  return data.boardCategories;
};

export const parseCommentsByComment = (
  data: GetBoardCommentBelongedBoardCommentsQuery,
): Array<BoardComment> => {
  return data.boardCommentBelongedBoardComments.map((comment) => {
    return {
      ...comment,
      formattedCreatedAt: displayedAt(comment.createdAt),
    };
  });
};

export const parseCommunityUser = (
  data: GetCommunityUserQuery,
): CommunityUser => {
  return {
    ...data,
    nickname: data.communityUser.nickname,
    userId: data.communityUser.userId,
    tutorialCompleted: data.communityUser.tutorialCompleted,
    profileImageUrl: data.communityUser.profileImageUrl,
    isAdmin: data.communityUser.isAdmin,
    bannedUntil: data.communityUser.bannedUntil ?? undefined,
    formattedBannedDate: data.communityUser.bannedUntil
      ? dayjs(data.communityUser.bannedUntil).format(
          'YYYY년 MM월 DD일 HH시까지',
        )
      : undefined,
    isBanned: dayjs().isBefore(data.communityUser.bannedUntil),
  };
};

export const parseMagazineRelatedBoardPost = (
  posts: GetMagazineRelatedBoardPostsQuery,
): Array<MagazineRelatedPost> => {
  if (posts) {
    return posts.magazineRelatedBoardPosts.map((post) => {
      return {
        ...post,
        boardPostAttachmentId:
          post.boardPostAttachments.filter(
            (attachment) => attachment.blindType === 'NONE',
          ).length > 0
            ? post.boardPostAttachments.filter(
                (attachment) => attachment.blindType === 'NONE',
              )[0].boardPostAttachmentId
            : null,
      };
    });
  }
  return [];
};
